"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as e } from "react";
import r from "../components/Icon/SvgIcon.js";
const t = (l) => /* @__PURE__ */ o(
  r,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m13.375 5.008 7.836 13.713a.5.5 0 0 1-.434.748H2.5a.5.5 0 0 1-.434-.748L9.902 5.008a2 2 0 0 1 3.473 0",
        clipRule: "evenodd"
      }
    )
  }
), n = e(t);
export {
  n as ArrowUpFilled,
  n as default
};
